import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'
import { v1Client } from 'src/utils/apiClient'
import type {
  ISystemLogQueryParams,
  ISystemLogQueryResponse,
} from 'src/interfaces/log'

class LogLoader extends Loader {}

export const logLoader = new LogLoader({
  service: SERVICES.log,
})

// Pagination (limit/offset) travels in the body; sort/filter travel as query
// params — matching the exact wire contract the legacy grid already used
// (src/hotpots/utils/apiData.ts), since this isn't a REST CRUD resource and
// there's no confirmation the backend accepts a different shape.
export const queryLogs = ({
  limit,
  offset,
  orders,
  filters,
}: ISystemLogQueryParams) =>
  v1Client.post<ISystemLogQueryResponse>(
    `${SERVICES.log}/queryLogs`,
    { limit, offset },
    { orders, filters },
  )
